module.exports = __webpack_public_path__ + "img/img45.6174a4aa.png";